import React from 'react';
import colors from 'src/style/colors';
import { mediaQueries } from 'src/style/breakpoints';

const ContentCardsSection = ({
  title,
  subtitle,
  cards,
  columns = 3,
  ctaButton,
  backgroundColor = colors.white,
}) => {
  return (
    <section
      css={{
        padding: '5rem 2rem',
        backgroundColor,
        [mediaQueries.phoneOnly]: {
          padding: '3rem 1rem',
        },
      }}
    >
      <div
        css={{
          maxWidth: 1200,
          margin: '0 auto',
        }}
      >
        <h2
          css={{
            textAlign: 'center',
            fontSize: '2.5rem',
            marginBottom: '1rem',
            color: colors.purpleDark,
            fontWeight: 700,
            [mediaQueries.phoneOnly]: {
              fontSize: '1.75rem',
            },
          }}
        >
          {title}
        </h2>

        {subtitle && (
          <p
            css={{
              textAlign: 'center',
              fontSize: '1.25rem',
              color: colors.darkGrey,
              marginBottom: '3rem',
              [mediaQueries.phoneOnly]: {
                fontSize: '1rem',
                marginBottom: '2rem',
              },
            }}
          >
            {subtitle}
          </p>
        )}

        <div
          css={{
            display: 'grid',
            gridTemplateColumns: `repeat(${columns}, 1fr)`,
            gap: '2rem',
            '@media only screen and (max-width: 1024px)': {
              gridTemplateColumns: 'repeat(2, 1fr)',
            },
            [mediaQueries.phoneOnly]: {
              gridTemplateColumns: '1fr',
              gap: '1.5rem',
            },
          }}
        >
          {cards.map((card, index) => (
            <div
              key={index}
              css={{
                backgroundColor: colors.white,
                padding: '2rem',
                borderRadius: 16,
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: '0 12px 30px rgba(0, 0, 0, 0.15)',
                },
                [mediaQueries.phoneOnly]: {
                  padding: '1.5rem',
                },
              }}
            >
              <div
                css={{
                  width: 60,
                  height: 60,
                  background: `linear-gradient(135deg, ${colors.purple} 0%, ${colors.purpleLight} 100%)`,
                  borderRadius: 12,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.75rem',
                  marginBottom: '1.5rem',
                }}
              >
                {card.icon}
              </div>

              <h3
                css={{
                  fontSize: '1.25rem',
                  marginBottom: '1rem',
                  color: colors.purpleDark,
                  fontWeight: 700,
                  lineHeight: 1.3,
                  [mediaQueries.phoneOnly]: {
                    fontSize: '1.15rem',
                  },
                }}
              >
                {card.title}
              </h3>

              <p
                css={{
                  color: colors.darkGrey,
                  lineHeight: 1.7,
                  margin: 0,
                  fontSize: '1rem',
                }}
              >
                {card.description}
              </p>
            </div>
          ))}
        </div>

        {ctaButton && (
          <div css={{ textAlign: 'center', marginTop: '3rem' }}>{ctaButton}</div>
        )}
      </div>
    </section>
  );
};

export default ContentCardsSection;
